var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0676 3.46094H5.88424C5.42233 3.46094 4.97933 3.64443 4.6527 3.97106C4.32607 4.29769 4.14258 4.74069 4.14258 5.2026V33.3859C4.14258 33.6147 4.18763 33.8411 4.27515 34.0524C4.36268 34.2638 4.49097 34.4558 4.6527 34.6175C4.81443 34.7792 5.00643 34.9075 5.21774 34.995C5.42905 35.0826 5.65553 35.1276 5.88424 35.1276H21.0526V22.8568H16.9359V18.1068H21.0526V14.5443C20.9673 13.7079 21.066 12.863 21.3419 12.0688C21.6177 11.2746 22.064 10.5504 22.6493 9.94692C23.2347 9.34346 23.945 8.87537 24.7304 8.57548C25.5158 8.27559 26.3573 8.15117 27.1959 8.21094C28.4283 8.20335 29.66 8.26679 30.8851 8.40094V12.6759H28.3676C26.3726 12.6759 25.9926 13.6259 25.9926 15.0034V18.0593H30.7426L30.1251 22.8093H25.9926V35.1276H34.0676C34.2963 35.1276 34.5228 35.0826 34.7341 34.995C34.9454 34.9075 35.1374 34.7792 35.2991 34.6175C35.4609 34.4558 35.5891 34.2638 35.6767 34.0524C35.7642 33.8411 35.8092 33.6147 35.8092 33.3859V5.2026C35.8092 4.97389 35.7642 4.74741 35.6767 4.5361C35.5891 4.32479 35.4609 4.13279 35.2991 3.97106C35.1374 3.80933 34.9454 3.68104 34.7341 3.59351C34.5228 3.50599 34.2963 3.46094 34.0676 3.46094Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b25f6dcf5efd1ed42e6acfeacdd0b937.svg";
export { ForwardRef as ReactComponent };